import React, { useState } from 'react'
import PropTypes from 'prop-types'
import * as Styled from './PresentationIndicators.styles'

import { Button, Tooltip } from 'components/atoms'
import { Overlay } from 'components/molecules'
import { Checkbox } from '../Filter/partials'

/**
 * @returns {*}
 * @constructor
 */
const PresentationIndicators = ({
  active,
  indicatorCollection,
  handleCheckboxChange,
  setIndicatorsHandler,
}) => {
  const [isActive, setIsActive] = useState(active)

  /**
   * return a checkbox indicator component
   * with device depending handler
   * @param indicator (key)
   * @param index
   * @returns {*}
   */
  const getCheckboxIndicator = ({ indicator, index }) => (
    <Checkbox
      key={ index }
      id={ indicator.key }
      data-cy={ indicator.key }
      value={ indicator.label }
      checked={ indicator.selected }
      handleChange={ () => handleCheckboxChange(indicator) }>
      <>
        {indicator.label}
        {null !== indicator.tip && undefined !== indicator.tip && (
          <Tooltip
            dialogTitle={ indicator.label }
            infoIconId={ `${ indicator.label }-icon-id` }
            tooltipId={ `${ indicator.label }-tip-id` }
            arrow='left'>
            {indicator.tip}
          </Tooltip>
        )}
      </>
    </Checkbox>
  )

  /**
   * map every indicator collection to the corresponding components
   * @returns {unknown[]} (component stack)
   */
  const getIndicators = () =>
    indicatorCollection.map((collection, collectionIndex) => (
      <Styled.PresentationIndicatorsComponent
        key={ `collection_${ collectionIndex }` }>
        <h5 className={ 'indicator-list-title' }>
          {collection.title}
          {null !== collection.tip && undefined !== collection.tip && (
            <Tooltip
              className={ 'indicator-list-title-tooltip' }
              dialogTitle={ collection.title }
              infoIconId={ `${ collection.label }-icon-id` }
              tooltipId={ `${ collection.label }-tip-id` }
              arrow='left'>
              {collection.tip}
            </Tooltip>
          )}
        </h5>
        {collection.indicators &&
          collection.indicators.map((indicator, indicatorIndex) => {
            // nested indicators
            if (indicator?.options) {
              return (
                <div
                  className={ 'indicator-group' }
                  key={ `indicator_${ indicatorIndex }` }>
                  <p className={ 'indicator-group-label' }>
                    {indicator.label}
                    {null !== indicator.tip && undefined !== indicator.tip && (
                      <Tooltip
                        dialogTitle={ indicator.label }
                        infoIconId={ `${ indicator.label }-icon-id` }
                        tooltipId={ `${ indicator.label }-tip-id` }
                        arrow='left'>
                        {indicator.tip}
                      </Tooltip>
                    )}
                  </p>
                  <div className={ 'indicator-group-options' }>
                    {indicator.options &&
                      indicator.options.map((indicatorOption, index) =>
                        getCheckboxIndicator({
                          indicator: indicatorOption,
                          index: `indicator_${ indicatorIndex }-${ index }`,
                        })
                      )}
                  </div>
                </div>
              )
            }

            // top-level indicators
            return getCheckboxIndicator({
              indicator,
              index: `indicator_${ indicatorIndex }`,
            })
          })}
      </Styled.PresentationIndicatorsComponent>
    ))

  return (
    <Overlay
      id={ 'presentation-indicators-overlay' }
      isActive={ isActive }
      title={ 'Indikatoren für die Darstellung auswählen' }
      iconName={ 'icon-f-funnel' }
      showClose={ true }>
      {getIndicators()}
      <Styled.CloseOverlayRow>
        <Button
          text={ 'Ergebnisse anzeigen' }
          onClick={ () => {
            setIsActive(false)
            setIndicatorsHandler()
          } }
        />
      </Styled.CloseOverlayRow>
    </Overlay>
  )
}

PresentationIndicators.defaultProps = {
  active: true,
}

PresentationIndicators.propTypes = {
  active: PropTypes.bool,
  indicatorCollection: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      tip: PropTypes.string,
      indicators: PropTypes.arrayOf(
        PropTypes.shape({
          key: PropTypes.string.isRequired,
          label: PropTypes.string.isRequired,
          tip: PropTypes.string,
          selected: PropTypes.bool.isRequired,
          options: PropTypes.arrayOf(
            PropTypes.shape({
              key: PropTypes.string.isRequired,
              label: PropTypes.string.isRequired,
              tip: PropTypes.string,
              selected: PropTypes.bool.isRequired,
            })
          ),
        })
      ).isRequired,
    })
  ).isRequired,
  handleCheckboxChange: PropTypes.func.isRequired,
  setIndicatorsHandler: PropTypes.func.isRequired,
}

export default PresentationIndicators
